import Splide from '@splidejs/splide';

export default function HeroSlider() {
  const slider = document.getElementById('HeroSlider');

  if (!slider) return;

  const config = {
    type: 'fade',
    arrows: false,
    autoplay: true,
    interval: 4000,
    drag: true,
    rewind: true,
    rewindByDrag: true,
    pagination: slider.dataset.count > 1,
    speed: 800
  };

  slider.classList.remove('no-js');

  new Splide(slider, config).mount();
}
